import React from "react";

/**
 * Hero block: success icon + title + subtitle (RTL).
 */
export default function SuccessHeader({
  title = "נרשמת בהצלחה ל-HotelsRiver",
  subtitle = "החשבון שלך מוכן – אפשר להתחיל לעבוד",
}) {
  return (
    <header className="success-reg-header">
      <div className="success-reg-header__icon" aria-hidden>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
          <path
            d="M20 6L9 17l-5-5"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <h1 className="success-reg-header__title">{title}</h1>
      <p className="success-reg-header__subtitle">{subtitle}</p>
    </header>
  );
}
